import ChecklistItem from '@/models/read/ChecklistItem';

class Checklist {
    constructor({ type: name, items }) {
        this._name = name;
        this._items = Object.values(items).map(item => new ChecklistItem(item));
    }

    get name() {
        return this._name;
    }

    get items() {
        return this._items;
    }
}

export default Checklist;
